import { useState } from 'react'
import { Alert, Button } from 'antd'
import { useAuthContext } from '../../context/auth'
import { supabase } from '../../utils/supabase'

export function EmailConfirmationBanner() {
  const { user } = useAuthContext()
  const [dismissed, setDismissed] = useState(false)
  const [resending, setResending] = useState(false)
  const [resent, setResent] = useState(false)

  if (!user || user.email_confirmed_at || dismissed) {
    return null
  }

  const handleResend = async () => {
    setResending(true)
    await supabase.auth.resend({ type: 'signup', email: user.email ?? '' })
    setResending(false)
    setResent(true)
  }

  return (
    <Alert
      type="warning"
      banner
      message={
        resent ? (
          'Confirmation email sent — check your inbox.'
        ) : (
          <>
            Please confirm your email address.{' '}
            <Button
              type="link"
              size="small"
              style={{ padding: 0 }}
              onClick={handleResend}
              loading={resending}
            >
              Resend email
            </Button>
          </>
        )
      }
      closable
      onClose={() => setDismissed(true)}
    />
  )
}
